import {
  NgModule,
} from '@angular/core';
import {
  RulesEngineRunnerModule,
} from '@o3r/rules-engine';
import {
  JourneyInformationFactsService,
} from './journey-information.facts.service';

@NgModule({
  imports: [
    RulesEngineRunnerModule
  ],
  providers: [
    JourneyInformationFactsService
  ]
})
export class JourneyInformationFactsModule {}
